module.exports = __webpack_public_path__ + "images/花筑奢pr长图_06-2.jpg?v=18ae9432";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/huazhu2/花筑奢pr长图_06-2.jpg
 ** module id = 38
 ** module chunks = 1 2
 **/